import { Provider, utils } from 'zksync-ethers';
import { BridgeMiddleware as BridgeMiddlewareAbi } from '../abis';
import { ChainLayer, } from '../types';
import { getContract, getProvider } from '../utils';
export class L2GasEstimator {
    constructor(l1providerOptions, l2providerOptions, contractAddressMap, signerOrProvider) {
        this.contractAddressMap = contractAddressMap;
        this.signerOrProvider = signerOrProvider;
        this.l1Provider = getProvider(l1providerOptions, ChainLayer.L1);
        this.l2Provider = new Provider(l2providerOptions.rpcUrl);
        this.middleware = this.createMiddlewareContract();
    }
    /**
     *
     * @param options for `depositTokenAddress`, use NATIVE_TOKEN_ADDRESS if it's ETH, else the token address
     * @param amount if Fraction, will automatically shift by token `decimals`. If `bigint`, you need to
     * provide correct decimals
     * @returns
     */
    async getL2GasEstimate({ depositorAddress, depositTokenAddress, amount, decimals, }) {
        const amountBigInt = typeof amount === 'bigint'
            ? amount
            : amount.shl(Number(decimals)).quotient;
        const l2GasPerPubdataByteLimit = utils.REQUIRED_L1_TO_L2_GAS_PER_PUBDATA_LIMIT;
        const [l1GasPrice, l2GasLimit] = await Promise.all([
            this.l1Provider.getFeeData().then((d) => d.maxFeePerGas),
            utils.estimateDefaultBridgeDepositL2Gas(this.l1Provider, this.l2Provider, depositTokenAddress, amountBigInt, depositorAddress, depositorAddress),
        ]);
        if (!l1GasPrice)
            throw new Error('maxFeePerGas should not be undefined on this network');
        const l2TxCostInETH = await this.middleware.l2TransactionEthCost(l1GasPrice, l2GasLimit, l2GasPerPubdataByteLimit);
        return { l2TxCostInETH, l2GasLimit };
    }
    createMiddlewareContract() {
        return getContract(this.contractAddressMap.BridgeMiddleware, BridgeMiddlewareAbi, this.signerOrProvider);
    }
}
